// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-uploader .avatar-icon {\n  cursor: pointer;\n  height: 80px;\n  min-width: 80px;\n  width: 80px;\n  margin: 4px;\n  position: relative;\n}\n.avatar-images {\n  cursor: pointer;\n}\n.avatar-popover {\n  z-index: 203;\n  background-color: var(--v-primary-base);\n  border-radius: 4px;\n  max-width: 400px;\n}\n@media (max-width: 550px) {\n.avatar-popover .tooltip-inner {\n    padding: 10px !important;\n}\n}", ""]);
// Exports
module.exports = exports;
